function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
import { jsx as _jsx } from "react/jsx-runtime";
import React, { forwardRef, useMemo } from "react";
import PropTypes from "prop-types";
import logger from "../../logger";
import { LPEHOC } from "../LPEHOC";
import useRemoteModule from "../../hooks/useRemoteModule";
import { SkeletonLoader } from "../utilities/SkeletonLoader";
var DynamicTestWrapper = /*#__PURE__*/ forwardRef(function DynamicTestWrapper(props, ref) {
    var _props_children = props.children, children = _props_children === void 0 ? null : _props_children, name = props.config.name;
    var abtConfig = useRemoteModule({
        remote: "abtFederationHost",
        module: "mboxConfigs"
    });
    var combinedProps = useMemo(function() {
        var remoteProps = _extends({}, props);
        try {
            var _abtConfig, _abtConfig1;
            if (((_abtConfig = abtConfig) == null ? void 0 : _abtConfig.default) && typeof ((_abtConfig1 = abtConfig) == null ? void 0 : _abtConfig1.default) === "function") {
                return _extends({}, abtConfig.default(name, remoteProps));
            }
        } catch (error) {
            logger.error("Error while trying to apply remote config for mobx: '" + {
                abtConfig: abtConfig,
                props: props
            } + "'", error);
        }
        return remoteProps;
    }, [
        abtConfig,
        props,
        name
    ]);
    var abTestEndDate = combinedProps.abTestEndDate;
    var ended = useMemo(function() {
        var expiredDate = Date.parse(abTestEndDate);
        return Number.isNaN(expiredDate) || expiredDate < Date.now();
    }, [
        abTestEndDate
    ]);
    // abTestEndDate overdue
    if (ended) {
        return children;
    }
    // abtConfigs unresolved
    if (abtConfig === null) {
        return /*#__PURE__*/ _jsx(SkeletonLoader, {
            ref: ref,
            children: children
        });
    }
    // abtConfigs resolved
    return /*#__PURE__*/ _jsx(LPEHOC, _extends({}, combinedProps, {
        ref: ref
    }));
});
DynamicTestWrapper.propTypes = {
    abTestEndDate: PropTypes.string.isRequired
};
export { DynamicTestWrapper };

//# sourceMappingURL=DynamicTestWrapper.js.map